import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-value"]
const _hoisted_2 = {
  key: 0,
  class: "pl-2"
}

import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {TreeItemInterface} from "~/core-ui/vue/ui/tree-select/Interface";
import Events from "~/ts/library/Events";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import {ref} from "vue";
import Random from "~/ts/library/Random";


const __default__ = {
    name: "MyTreeSelect"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    data: {},
    placeholder: {},
    disabled: { type: Boolean },
    clearable: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {




let id = ref(`treeSelect_${Random.uid(20)}`);

function generateId() {
    id.value = `treeSelect_${Random.uid(20)}`;
}

let model = _useModel<string | number>(__props, "modelValue");

function filterNodeMethod(value: string, data: TreeItemInterface) {
    value = value.toLowerCase();
    return data.value.toString().toLowerCase().includes(value);
}


addDisposableEvent(Events.addEventListener("keyup", document, (e: KeyboardEvent) => {
    if (e.code === "Enter") {
        let target = e.target as HTMLElement;
        if (target.classList.contains(`el-tree-node`)) {
            let element = target.querySelector(`.${id.value}`);
            if (element) {
                let value = element.getAttribute("data-value");
                if (typeof value === "string") {
                    model.value = value;
                    generateId();
                }
            }
        }
    }
}));

return (_ctx: any,_cache: any) => {
  const _component_el_tree_select = _resolveComponent("el-tree-select")!

  return (_openBlock(), _createBlock(_component_el_tree_select, {
    modelValue: _unref(model),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event)),
    placeholder: __props.placeholder,
    persistent: false,
    filterable: "",
    data: __props.data,
    disabled: __props.disabled,
    clearable: __props.clearable,
    key: _unref(id),
    "popper-class": "my-tree-popper",
    "default-expand-all": "",
    "filter-node-method": filterNodeMethod
  }, {
    default: _withCtx(({ data: { label, children, value } }) => [
      _createElementVNode("div", {
        class: _normalizeClass({
                    'd-flex content w-100 my-tree-select-item': true,
                    [_unref(id)]: true
                }),
        "data-value": (children ?? []).length > 0 ? undefined : value
      }, [
        _createElementVNode("div", {
          class: _normalizeClass({
                        'flex-fill': true,
                        'group-label': (children ?? []).length > 0
                    })
        }, _toDisplayString(label), 3),
        ((children ?? []).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(FontAwesomeIcon, {
                class: "chevron down d-none",
                icon: "chevron-down"
              }),
              _createVNode(FontAwesomeIcon, {
                class: "chevron right",
                icon: "chevron-right"
              })
            ]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1)
    ]),
    _: 1
  }, 8, ["modelValue", "placeholder", "data", "disabled", "clearable"]))
}
}

})